import React from 'react';

interface DefaultBPIconProps {
  color?: string;
}

const DefaultBPIcon: React.FC<DefaultBPIconProps> = ({ color }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7687_42365)">
        <rect width="48" height="48" rx="24" fill={color ? color : '#8BBC07'} />
        <path
          d="M25.1667 19.3983C25.462 20.0381 25.673 20.495 25.673 20.495C25.9683 20.5864 28.9217 19.2155 29.6389 16.9306C30.3562 14.6457 28.8795 11.3097 28.5841 11.1726C28.3732 11.0812 26.8121 11.9495 25.6308 13.1833"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M22.8333 19.2612C22.5432 19.9924 22.2531 20.495 22.2531 20.495C21.963 20.5864 19.0621 19.2155 18.3576 16.9306C17.6531 14.6457 19.1036 11.3097 19.3936 11.1726C19.6009 11.0812 21.1342 11.9495 22.2946 13.229"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24.0181 20.4993C24.2713 20.4993 26.3333 18.242 26.3333 15.9846C26.3333 13.7273 24.2713 11.166 24.0181 11.166C23.7648 11.166 21.6667 13.8141 21.6667 15.9846C21.6667 18.1552 24.0181 20.4993 24.0181 20.4993Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24 36.8333C24 36.8333 22.8034 33.6065 20.3729 31.2959C18.1667 29.1846 18.1667 28.1089 18.1667 26.1569C18.1667 24.2049 20.2981 20.5 24 20.5M24 36.8333C24 36.8333 25.1966 33.6065 27.6271 31.2959C29.8333 29.1846 29.8333 28.1089 29.8333 26.1569C29.8333 24.2049 27.6645 20.5 24 20.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="0.8"
        y="0.8"
        width="46.4"
        height="46.4"
        rx="23.2"
        stroke="white"
        strokeWidth="1.6"
      />
      <defs>
        <clipPath id="clip0_7687_42365">
          <rect width="48" height="48" rx="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DefaultBPIcon;
